import {enableProdMode, ErrorHandler, importProvidersFrom, LOCALE_ID} from '@angular/core';
import {environment} from './environments/environment';
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app/app.component";
import {ApiService} from "./app/services/api/api.service";
import {AuthenticationService} from "./app/services/auth/authentication.service";
import {AuthorisationService} from "./app/services/auth/authorisation.service";
import {UserService} from "./app/services/user/user.service";
import {ArticleService} from "./app/services/article.service";
import {CustomerAreaService} from "./app/services/consumer-area/customer-area.service";
import {ConfirmDialogService} from "./app/services/confirm-dialog-service/confirm-dialog.service";
import {LocationService} from "./app/pushpin-detail/location-selector-dialog/location.service";
import {CameraService} from "./app/camera.service";
import {CordovaService} from "./app/cordova.service";
import {FileService} from "./app/services/file.service";
import {GpsService} from "./app/gps.service";
import {DatePipe, DecimalPipe, registerLocaleData} from "@angular/common";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {CdkDropList} from "@angular/cdk/drag-drop";
import {CanDeactivateForm} from "./app/can-deactivate-form";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {FirebaseX} from "@awesome-cordova-plugins/firebase-x/ngx";
import {CustomErrorHandlerService} from "./app/custom-error-handler-service";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport} from "@angular/common/http";
import {CodaltInterceptor} from "./app/codalt.interceptor";
import {provideRouter} from "@angular/router";
import {provideNativeDateAdapter} from "@angular/material/core";
import {routes} from "./app/app-routing/app-routing.module";
import localeNL from '@angular/common/locales/nl';
import {CanDeactivatePushpinDetail} from "./app/app-routing/can-deactivate-pushpin-detail";
import {CanDeactivateEdit} from "./app/app-routing/can-deactivate-edit.service";
import {CanDeactivateIncidentComment} from "./app/app-routing/can-deactivate-incident-comment";
import {GoogleMapsModule} from "@angular/google-maps";

if (environment.production) {
    enableProdMode();
}

registerLocaleData(localeNL, 'nl');


bootstrapApplication(AppComponent, {
    providers: [
        ApiService,
        AuthenticationService,
        AuthorisationService,
        UserService,
        ArticleService,
        CustomerAreaService,
        ConfirmDialogService,
        LocationService,
        CameraService,
        CordovaService,
        FileService,
        GpsService,
        DatePipe,
        DecimalPipe,
        MatBottomSheet,
        CdkDropList,
        CanDeactivateForm,
        CdkVirtualScrollViewport,
        FirebaseX,
        CanDeactivatePushpinDetail,
        CanDeactivateEdit,
        CanDeactivateIncidentComment,
        {provide: ErrorHandler, useClass: CustomErrorHandlerService},
        {provide: LOCALE_ID, useValue: 'nl'},
        {provide: HTTP_INTERCEPTORS, useClass: CodaltInterceptor, multi: true},
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
        provideNativeDateAdapter(),
        importProvidersFrom(GoogleMapsModule)
    ]
})
    .catch((err) => console.error(err));
